import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Flex } from 'nallian-shared-ui/lib/components';
import PrincipalAutoCompleteValueComponent from '../../../app/components/PrincipalAutoCompleteValueComponent';

const AddUserGroupMember = ({ handleAddMember, organisationId }) => {
  const { t } = useTranslation();

  const handleOnChange = useCallback((_, { value }) => handleAddMember(value), [handleAddMember]);

  return (
    <Flex fluid direction="column">
      <Flex margin="0 0 0.5rem">
        <label htmlFor="_">
          <strong>{t('searchAndAddMember')}</strong>
        </label>
      </Flex>
      <PrincipalAutoCompleteValueComponent
        hideLabel
        clearAfterChange
        onChange={handleOnChange}
        organisationId={organisationId}
        placeholder={t('searchForNameOrEmailOfUser')}
      />
    </Flex>
  );
};

AddUserGroupMember.propTypes = {
  organisationId: PropTypes.string.isRequired,
  handleAddMember: PropTypes.func.isRequired,
};

export default AddUserGroupMember;
